<div class="more-options-container" [id]="uniqueId">
    <div [ngClass]="openDropdown ? 'dots-button-selected' : 'dots-button'" (click)="toggleDropdown()">
        <img src="../../../assets/icons/datatable-dots-horizontal.svg" alt="Dots Menu" />
    </div>
    <div class="more-options-dropdown" *ngIf="openDropdown" [style.top]="top" [style.right]="right">
        <div *ngFor="let menuOption of menuOptions; let last = last; let first = first">
            <div class=" button-option" [ngClass]="{'first-option': first, 'last-option': last}"
                (click)="optionEmit(menuOption.id)">
                <img [src]="menuOption.icon" [alt]="menuOption.alt" />
                <span>{{menuOption.text}}</span>
            </div>
            <div class="split" *ngIf="!last"></div>
        </div>
    </div>
</div>